import { useEffect } from 'react';

export function useKeyCodes(ref, keyCodes) {
  useEffect(() => {
    const container = ref.current;
    const listener = (ev) => {
      const handler = keyCodes[ev.keyCode];
      if (handler) {
        handler(ev);
        return;
      }
    };

    if (!container) {
      console.warn('no reference to add listener');
      return;
    }

    container.addEventListener('keydown', listener);

    return () => {
      container.removeEventListener('keydown', listener);
    };
  }, [keyCodes, ref]);
}
